import type { BuildingStorageQuota } from "../services/buildingStorageQuota";
import { storageState } from "./storagePresentation";

export class StorageBatchFeedback {
  readonly handled = new Set<string>();
  private fullAnnounced: boolean;
  constructor(initial?: BuildingStorageQuota) {
    this.fullAnnounced = initial ? storageState(initial) === "full" : false;
  }
  observe(quota: BuildingStorageQuota) {
    if (storageState(quota) !== "full") this.fullAnnounced = false;
  }
  complete(batchId: string, quota: BuildingStorageQuota): "near" | "full" | null {
    if (this.handled.has(batchId)) return null;
    this.handled.add(batchId);
    if (quota.activationPending) return null;
    const state = storageState(quota);
    if (state === "full") {
      if (this.fullAnnounced) return null;
      this.fullAnnounced = true;
      return "full";
    }
    this.fullAnnounced = false;
    return state === "near" ? "near" : null;
  }
}

export const STORAGE_ADMISSION_EVENT = "building-storage-admission-error";
export function reportStorageAdmissionFailure(buildingId: string, orgId: string): void {
  window.dispatchEvent(new CustomEvent(STORAGE_ADMISSION_EVENT, { detail: { buildingId, orgId } }));
}
